var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShopify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24.87,
    viewBox: "0 0 22 24.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#95bf46;}.b{fill:#5e8e3e;}.c{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,22.212S1.832,8.135,1.9,7.639c.093-.656.114-.678.814-.9.113-.036,1-.31,2.258-.7C5.456,4.01,7,0,10.224,0a1.687,1.687,0,0,1,1.3.743c.04,0,.079,0,.117,0,1.385,0,2.173,1.173,2.619,2.449l.747-.23a.612.612,0,0,1,.545.069l1.481,1.463,2.014.149a.241.241,0,0,1,.219.2C19.286,4.967,22,23.207,22,23.207L14.269,24.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.732,1.712l-1.993-.15S1.417.241,1.272.094A.361.361,0,0,0,1.068,0L0,22l7.652-1.667S4.966,2.04,4.949,1.914a.24.24,0,0,0-.216-.2",
    transform: "translate(14.348 2.87)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M8.609.366,7.616,3.144a4.788,4.788,0,0,0-1.935-.437c-1.562,0-1.641.923-1.641,1.155,0,1.269,3.514,1.755,3.514,4.727a3.6,3.6,0,0,1-3.7,3.844A5.278,5.278,0,0,1,0,10.941L.683,8.818A5,5,0,0,0,3.154,9.9a.968.968,0,0,0,1.04-.948C4.194,7.3,1.31,7.224,1.31,4.5,1.31,2.215,3.056,0,6.58,0A4.559,4.559,0,0,1,8.609.366",
    transform: "translate(2.87 8.609)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShopify);
export default __webpack_public_path__ + "static/media/logo-shopify.98e3f7cf77d4661ce67d796d1158e923.svg";
export { ForwardRef as ReactComponent };